import { lazy } from "react";
import { RouteObject } from "react-router-dom";

import { RouterGuard } from "../guard";

const CoursewareReview = lazy(() => import("@/pages/mobile/courseware-review"));

const TutorialPreview = lazy(() => import("@/pages/mobile/tutorial-preview"));

const CoursewareSharing = lazy(
  () => import("@/pages/mobile/courseware-sharing")
);

const Tour = lazy(() => import("@/pages/mobile/tour"));

const DownloadApp = lazy(() => import("@/pages/mobile/download-app"));

const mobile: RouteObject[] = [
  {
    path: "/m/courseware-review",
    element: <RouterGuard element={<CoursewareReview />} />,
    children: [],
  },
  {
    path: "/m/tutorial-preview",
    element: <RouterGuard element={<TutorialPreview />} />,
    children: [],
  },
  {
    path: "/sharing/:token",
    element: <RouterGuard element={<CoursewareSharing />} />,
    children: [],
  },
  {
    path: "/m/tour",
    element: <RouterGuard element={<Tour />} valid={false} />,
  },
  {
    path: "/m/download-app",
    element: <RouterGuard element={<DownloadApp />} valid={false} />,
  },
];

export default mobile;
